import React, { ReactNode } from 'react';

// Module Components
import SectionHeading from './SectionHeading';

// Constants
import { STRINGS } from '../../../constants';

interface FieldsSectionProps {
  /** The section body: the field list. */
  children: ReactNode;
}

/**
 * The pane's second labelled section (spec R62): "Fields", and below the heading the
 * field list.
 *
 * The heading sits in its own block on the subtle section-header fill, closed by a
 * bottom border, and the section itself is closed by one — the panel anatomy the
 * incumbent builder uses for every labelled group (spec R79, R81).
 *
 * The field **search** is no longer here: it is the pane's own top block now, above
 * every labelled section (spec R62). Nothing else about this section changed.
 *
 * It is the pane's one *growing* section (`md:tw-flex-1`): while the pane is a bounded
 * column, the heading keeps its own height and the list below it takes the rest, which
 * is what gives the list a real height to scroll against instead of a viewport
 * fraction that knows nothing about the chrome above it (spec R74).
 *
 * All of it stays exactly as it is while a properties panel is open — the panel is a
 * column beside the preview, so nothing in this section is ever swapped out or
 * displaced by it (spec R42, R59, R63).
 */
const FieldsSection = ({ children }: FieldsSectionProps) => (
  <section className="tw-flex tw-flex-col tw-min-h-0 md:tw-flex-1 tw-border-b tw-border-edge">
    <div className="tw-px-3 tw-py-2 tw-bg-surface-sunken tw-border-b tw-border-edge">
      <SectionHeading>{STRINGS.pane.fieldsTitle}</SectionHeading>
    </div>

    {children}
  </section>
);

export default FieldsSection;
